import { ListType, ListItemType, listTypeHotkeyMap } from './constants.mjs';
import { isElement } from '../../../../core/utilities/nodes/elements/isElement.mjs';
import { createElement } from '../../../../core/utilities/nodes/elements/createElement.mjs';

function isList(node) {
  return isElement(node) && node.type === ListType;
}
function isListItem(node) {
  return isElement(node) && node.type === ListItemType;
}
function createListElement(listType, listItems = []) {
  return createElement(ListType, {
    listType
  }, listItems);
}
function createListItemElement(children) {
  return createElement(ListItemType, {}, children);
}
function getListTypeHotkey(listType) {
  return listTypeHotkeyMap[listType];
}

export { createListElement, createListItemElement, getListTypeHotkey, isList, isListItem };
